<template>
  <v-container fluid>
    <!-- ヘッダー -->
    <v-row>
      <v-col cols="12">
        <h2>
          <v-icon class="mr-2"> mdi-bank </v-icon>
          排出事業者
        </h2>
        <v-spacer class="mt-2" />
      </v-col> </v-row
    ><!-- /ヘッダー -->

    <!-- 検索ブロック -->
    <v-row>
      <v-col>
        <v-expansion-panels v-model="expansionPanel" accordion>
          <v-expansion-panel>
            <v-expansion-panel-header
              class="panel-header-color panel-selectable"
            >
              <strong>
                <v-icon class="panel-header-color"> mdi-magnify </v-icon>
                &nbsp;条件を指定して検索
              </strong>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <v-card flat>
                <v-card-text>
                  <!-- フリーワード、加入者番号、マニフェスト区分 -->
                  <v-row>
                    <v-col cols="12" md="6">
                      <v-text-field
                        v-model="searchForm.free_word"
                        clearable
                        dense
                        hide-details="auto"
                        label="排出事業者名称・事業場名称・事業者コード・事業場コード（空白区切り可）"
                        outlined
                        persistent-placeholder
                        placeholder="例）DXE 丸の内 001"
                        ref="free_word"
                        rounded
                        @blur="searchButtonClickEvent"
                        @click:clear="
                          searchForm.free_word = null;
                          searchButtonClickEvent();
                        "
                      >
                      </v-text-field>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-text-field
                        v-model="searchForm.subscriberNo"
                        dense
                        hide-details="auto"
                        label="加入者番号"
                        clearable
                        outlined
                        persistent-placeholder
                        rounded
                        @blur="searchButtonClickEvent"
                        @click:clear="
                          searchForm.subscriberNo = null;
                          searchButtonClickEvent();
                        "
                      />
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-select
                        v-model="searchForm.manifestType"
                        :items="manifestTypes"
                        dense
                        hide-details="auto"
                        label="マニフェスト区分"
                        clearable
                        outlined
                        persistent-placeholder
                        rounded
                        @change="searchButtonClickEvent"
                      />
                    </v-col>
                  </v-row>
                  <!-- /フリーワード、加入者番号、マニフェスト区分 -->

                  <!-- 請求先コード、請求先名、事業場未設定のみ、請求先未設定のみ -->
                  <v-row>
                    <v-col v-if="isBilling" cols="12" md="3">
                      <v-text-field
                        v-model="searchForm.billingAddressCode"
                        dense
                        hide-details="auto"
                        label="請求先コード"
                        clearable
                        outlined
                        persistent-placeholder
                        rounded
                        @blur="searchButtonClickEvent"
                        @click:clear="
                          searchForm.billingAddressCode = null;
                          searchButtonClickEvent();
                        "
                      />
                    </v-col>
                    <v-col v-if="isBilling" cols="12" md="3">
                      <v-text-field
                        v-model="searchForm.billingAddressName"
                        dense
                        hide-details="auto"
                        label="請求先名"
                        clearable
                        outlined
                        persistent-placeholder
                        placeholder="部分一致で検索"
                        rounded
                        @blur="searchButtonClickEvent"
                        @click:clear="
                          searchForm.billingAddressName = null;
                          searchButtonClickEvent();
                        "
                      />
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-radio-group
                        row
                        dense
                        class="pt-0 mt-0"
                        label=""
                        hide-details="auto"
                      >
                        <v-checkbox
                          v-model="searchForm.unregisterLocation"
                          dense
                          hide-details="auto"
                          label="事業場未設定のみ"
                          @change="searchButtonClickEvent"
                        />
                        &emsp;
                        <v-checkbox
                          v-if="isBilling"
                          v-model="searchForm.unregisterBillingAddress"
                          dense
                          hide-details="auto"
                          label="請求先未設定のみ"
                          @change="searchButtonClickEvent"
                        />
                      </v-radio-group>
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-select
                        v-model="searchForm.sortType"
                        :items="sortTypes"
                        dense
                        hide-details="auto"
                        label="表示順"
                        outlined
                        persistent-placeholder
                        rounded
                        style="font-size: 80%"
                        @change="searchButtonClickEvent"
                      />
                    </v-col>
                  </v-row>
                  <!-- /請求先コード、請求先名、事業場未設定のみ、請求先未設定のみ -->

                  <!-- メールアドレス設定、EDI申請ステータス、DXE排出モード、排出者メール承認 -->
                  <v-row>
                    <v-col cols="12" md="3">
                      <v-select
                        v-model="searchForm.mailAddressSetting"
                        :items="mailAddressSettings"
                        dense
                        hide-details="auto"
                        label="メールアドレス設定"
                        clearable
                        outlined
                        persistent-placeholder
                        rounded
                        @change="searchButtonClickEvent"
                      />
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-select
                        v-model="searchForm.ediRequestStatus"
                        :items="ediRequestStatuses"
                        dense
                        hide-details="auto"
                        label="EDI申請ステータス"
                        clearable
                        outlined
                        persistent-placeholder
                        rounded
                        @change="searchButtonClickEvent"
                      />
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-select
                        v-model="searchForm.dxeEmissionMode"
                        :items="dxeEmissionModes"
                        dense
                        hide-details="auto"
                        label="DXE排出モード"
                        clearable
                        outlined
                        persistent-placeholder
                        rounded
                        @change="searchButtonClickEvent"
                      />
                    </v-col>
                    <v-col cols="12" md="3">
                      <v-select
                        v-model="searchForm.emitterMailApproval"
                        :items="emitterMailApprovals"
                        dense
                        hide-details="auto"
                        label="排出者メール承認"
                        clearable
                        outlined
                        persistent-placeholder
                        rounded
                        @change="searchButtonClickEvent"
                      />
                    </v-col>
                  </v-row>
                  <!-- /メールアドレス設定、EDI申請ステータス、DXE排出モード、排出者メール承認 -->
                </v-card-text>
                <v-card-actions>
                  <v-spacer />
                  <v-btn color="primary" @click="searchButtonClickEvent">
                    <v-icon>mdi-magnify</v-icon>&nbsp;検索
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-col>
    </v-row>
    <!-- /検索ブロック -->
    <v-row>
      <v-col class="text-right">
        <template v-if="$vuetify.breakpoint.mdAndUp">
          <v-btn color="info" @click="exportEmissionButtonClickEvent">
            <v-icon>mdi-file-download-outline</v-icon>&nbsp;排出事業者CSV出力
          </v-btn>
          &nbsp;
          <v-btn
            :disabled="isJwMode"
            color="info"
            @click="importEmissionButtonClickEvent"
          >
            <v-icon>mdi-file-upload-outline</v-icon>&nbsp;排出事業者CSV取込
          </v-btn>
          &emsp;
          <v-btn color="info" @click="exportLocationButtonClickEvent">
            <v-icon>mdi-file-download-outline</v-icon>&nbsp;排出事業場CSV出力
          </v-btn>
          &nbsp;
          <v-btn
            :disabled="isJwMode"
            color="info"
            @click="importLocationButtonClickEvent"
          >
            <v-icon>mdi-file-upload-outline</v-icon>&nbsp;排出事業場CSV取込
          </v-btn>
        </template>

        <template v-else>
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="info" dark v-bind="attrs" v-on="on">
                排出事業者CSV
                <v-icon small> mdi-file-outline </v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item @click="exportEmissionButtonClickEvent">
                <v-list-item-title> CSV出力 </v-list-item-title>
              </v-list-item>
              <v-list-item
                :disabled="isJwMode"
                @click="importEmissionButtonClickEvent"
              >
                <v-list-item-title> CSV取込 </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
          &nbsp;
          <v-menu offset-y>
            <template v-slot:activator="{ on, attrs }">
              <v-btn color="info" dark v-bind="attrs" v-on="on">
                排出事業場CSV
                <v-icon small> mdi-file-outline </v-icon>
              </v-btn>
            </template>
            <v-list dense>
              <v-list-item @click="exportLocationButtonClickEvent">
                <v-list-item-title> CSV出力 </v-list-item-title>
              </v-list-item>
              <v-list-item
                :disabled="isJwMode"
                @click="importLocationButtonClickEvent"
              >
                <v-list-item-title> CSV取込 </v-list-item-title>
              </v-list-item>
            </v-list>
          </v-menu>
        </template>
        <span v-if="$vuetify.breakpoint.mdAndUp"> &emsp; </span>
        <v-btn
          :disabled="isJwMode"
          color="primary"
          @click="addButtonClickEvent"
        >
          排出事業者の追加&nbsp;<v-icon>mdi-plus</v-icon>
        </v-btn>
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <custom-pagination
          :page-number="page"
          :per-page="perPage"
          :pagination="pagination"
          :total-visible="totalVisible"
          @pageChanged="changePage"
          @perPageChanged="changePerPage"
        />
      </v-col>
    </v-row>

    <v-row>
      <v-col>
        <v-card flat class="rounded-card">
          <v-data-table
            v-model="rowSelected"
            :headers="isBilling ? isBillingTableHeaders : tableHeaders"
            :items="emissions"
            disable-pagination
            :items-per-page="-1"
            disable-sort
            hide-default-footer
            show-select
            @toggle-select-all="selectedAllCheckboxClickEvent($event)"
            @click:row="toggleRowSelection"
          >
            <template
              v-slot:[`item.data-table-select`]="{ item, isSelected, select }"
            >
              <v-simple-checkbox
                v-model="item.selected"
                :value="isSelected"
                :disabled="item.disabled"
                :readonly="item.disabled"
                :class="{ 'disabled-checkbox': item.disabled }"
                @input="!item.disabled && select($event)"
                @click="checkboxClickEvent(item)"
              />
            </template>
            <!-- チェックボックスのカスタマイズ -->
            <!-- <template v-slot:[`item.data-table-select`]="{ item, isSelected, select }">
              <v-simple-checkbox
                :value="isSelected"
                :disabled="item.disabled"
                :readonly="item.disabled"
                :class="{ 'disabled-checkbox': item.disabled }"
                @input="!item.disabled && select($event)"
              />
            </template> -->
            <!-- /チェックボックスのカスタマイズ -->

            <!-- コード/加入者番号 -->
            <template v-slot:[`item.code`]="{ item }">
              <div>
                {{ item.code }}
              </div>
              <div>
                <span v-if="item.subscriber_number">
                  {{ item.subscriber_number }}
                </span>
                <span v-else> - </span>
              </div>
            </template>
            <!-- /コード/加入者番号 -->

            <template v-slot:[`item.name`]="{ item }">
              <div class="line-clamp one-clamp">{{ item.name }}</div>
              <div>{{ item.manifest_type | manifest_type_to_label }}</div>
            </template>
            <template v-slot:[`item.manifest_type`]="{ item }">
              {{ item.manifest_type | manifest_type_to_label }}
            </template>
            <template v-slot:[`item.address`]="{ item }">
              <div class="line-clamp one-clamp">{{ item.address || "-" }}</div>
              <div>{{ item.email_1 || "-" }}</div>
            </template>
            <template v-slot:[`item.approval_type`]="{ item }">
              <div v-if="item.manifest_type === 'dxe_form'">
                {{
                  item.approval_type
                    | approval_type_to_label(
                      item.manifest_type,
                      item.approval_type
                    )
                }}
              </div>
              <div v-else>-</div>
              <div>{{ item.invited ? "招待済" : "-" }}</div>
            </template>

            <!-- 請求先コード/請求先名 -->
            <template v-slot:[`item.billing_address_code`]="{ item }">
              <div>
                <span v-if="item.billing_address_code">
                  {{ item.billing_address_code }}
                </span>
                <span v-else> - </span>
              </div>
              <div>
                <span v-if="item.billing_address_name">
                  {{ item.billing_address_name | truncate(15) }}
                </span>
                <span v-else> - </span>
              </div>
            </template>
            <!-- /請求先コード/請求先名 -->

            <!-- EDI申請ステータス/メール送信日時 -->
            <template v-slot:[`item.edi_request_status`]="{ item }">
              <div>
                <span v-if="item.edi_request_status">
                  {{ item.edi_request_status | edi_status_label }}
                </span>
                <span v-else> - </span>
              </div>
              <div>
                <span v-if="item.edi_request_at">
                  {{ item.edi_request_at | moment_datetime }}
                </span>
                <span v-else> - </span>
              </div>
            </template>
            <!-- /EDI申請ステータス/メール送信日時 -->

            <template v-slot:[`item.location_registered`]="{ item }">
              <v-icon v-if="!item.location_registered" color="red">
                mdi-block-helper
              </v-icon>
            </template>

            <template v-slot:[`item.editable`]="{ item }">
              <v-btn
                v-if="$vuetify.breakpoint.smAndUp"
                icon
                color="info darken-2"
                @click="showButtonClickEvent(item)"
              >
                <v-icon>mdi-file-document-outline</v-icon>
              </v-btn>
              <v-btn
                v-else
                text
                color="info"
                @click="showButtonClickEvent(item)"
              >
                参照
              </v-btn>
              <v-btn
                v-if="$vuetify.breakpoint.smAndUp"
                :disabled="isJwMode"
                color="info darken-2"
                icon
                @click="editButtonClickEvent(item)"
              >
                <v-icon>mdi-note-edit</v-icon>
              </v-btn>
              <v-btn
                v-else
                :disabled="isJwMode"
                text
                color="info"
                @click="editButtonClickEvent(item)"
              >
                編集
              </v-btn>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <!-- ページャ -->
    <v-row class="mb-15">
      <v-col>
        <custom-pagination
          :page-number="page"
          :per-page="perPage"
          :pagination="pagination"
          :total-visible="totalVisible"
          @pageChanged="changePage"
          @perPageChanged="changePerPage"
        />
      </v-col>
    </v-row>
    <!-- /ページャ -->

    <!-- 固定フッター -->
    <v-footer
      fixed
      class="mb-13"
      color="white"
      width="100%;"
      style="overflow-x: auto"
    >
      <v-card flat width="100%">
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="primary"
            class="mr-3"
            :disabled="rowSelected.length <= 0"
            @click="sendEdiApplicationMailButtonClickEvent"
          >
            EDI申込メールを送信
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-footer>
    <!-- /固定フッター -->

    <!-- アップグレード誘導モーダル -->
    <trial-plan-guide-dialog
      :enable-dialog="enableTrialPlanGuideDialog"
      :from-emission="true"
      @closeCallback="dialogCloseCallback"
    />

    <!-- 確認ダイアログ -->
    <Confirm ref="confirm" />
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import DownloadMixin from "../../../../mixins/download-mixin";
import CustomPagination from "@/driver/components/_CustomPagination.vue";
import TrialPlanGuideDialog from "../../dialogs/_TrialPlanGuideDialog";
import Confirm from "@/components/Confirm.vue";

export default {
  name: "DriverMasterEmissionIndex",
  components: {
    CustomPagination,
    TrialPlanGuideDialog,
    Confirm,
  },
  mixins: [DownloadMixin],
  data() {
    return {
      expansionPanel: 0,
      page: 1,
      perPage: 50,
      totalVisible: 7,
      searchForm: {
        free_word: null,
        subscriberNo: null,
        manifestType: null,
        billingAddressCode: null,
        billingAddressName: null,
        unregisterLocation: false,
        unregisterBillingAddress: false,
        sortType: "sort_priority_asc",
        mailAddressSetting: null,
        ediRequestStatus: null,
        dxeEmissionMode: null,
        emitterMailApproval: null,
      },
      withDeleted: false,
      manifestTypes: [
        { value: "dxe_form", text: "電子マニフェスト(EDI)" },
        { value: "other_form", text: "電子マニフェスト(WEB)" },
        { value: "paper_form", text: "紙マニフェスト" },
        { value: "general_form", text: "一般廃棄物" },
      ],
      mailAddressSettings: [
        { value: "registered", text: "設定済" },
        { value: "unregistered", text: "未設定" },
      ],
      ediRequestStatuses: [
        { value: "none_request", text: "-" },
        { value: "mail_send", text: "メール送信済" },
        { value: "mail_bounce", text: "メール送信エラー" },
        { value: "emission_requested", text: "排出申込済" },
        { value: "jwnet_requested", text: "JWNET申請中" },
        { value: "edi_available", text: "EDI利用可能" },
        { value: "edi_completed", text: "EDI登録完了" },
      ],
      dxeEmissionModes: [
        { value: "invited", text: "招待済" },
        { value: "uninvited", text: "未招待" },
      ],
      emitterMailApprovals: [
        { value: "use_approval", text: "利用する" },
        { value: "none_use_approval", text: "利用しない" },
      ],
      isBillingTableHeaders: [
        { text: "事業者コード\r\n加入者番号", value: "code", width: "10%" },
        { text: "会社名\r\nマニフェスト区分", value: "name", width: "15%" },
        { text: "住所\r\nメールアドレス１", value: "address", width: "20%" },
        {
          text: "請求先コード\r\n請求先名",
          value: "billing_address_code",
          width: "15%",
        },
        {
          text: "排出者メール承認\r\nDXE排出モード",
          value: "approval_type",
          width: "10%",
        },
        {
          text: "EDI申請ステータス\r\nEDI申請メール送信日時",
          value: "edi_request_status",
          width: "10%",
        },
        { text: "表示順", value: "sort_priority", align: "right", width: "5%" },
        {
          text: "事業場警告",
          value: "location_registered",
          align: "center",
          width: "5%",
        },
        { text: "詳細・編集", value: "editable", align: "end", width: "10%" },
      ],
      tableHeaders: [
        { text: "事業者コード\r\n加入者番号", value: "code" },
        { text: "会社名", value: "name" },
        { text: "マニフェスト区分", value: "manifest_type" },
        { text: "住所", value: "address" },
        {
          text: "排出者メール承認\r\nDXE排出モード",
          value: "approval_type",
          width: "10%",
        },
        {
          text: "EDI申請ステータス\r\nEDI申請メール送信日時",
          value: "edi_request_status",
          width: "10%",
        },
        { text: "表示順", value: "sort_priority", align: "right" },
        { text: "事業場警告", value: "location_registered", align: "center" },
        { text: "詳細・編集", value: "editable", align: "end" },
      ],
      /* 表示順 */
      sortTypes: [
        { value: "sort_priority_desc", text: "表示順（降順）▼" },
        { value: "sort_priority_asc", text: "表示順（昇順）▲" },
        { value: "updated_date_desc", text: "更新日（降順）▼" },
        { value: "updated_date_asc", text: "更新日（昇順）▲" },
      ],
      enableTrialPlanGuideDialog: false,
      emissions: [],
      rowSelected: [],
    };
  },
  /**
   * @property isDemoEnv { boolean }
   */
  computed: {
    ...mapState("DriverTenantConfiguration", {
      isBilling: "use_billing",
      isJwMode: "use_jw_mode",
      isTrialPlan: "use_trial_plan",
    }),
    ...mapState("DriverMasterEmission", {
      pagination: "pagination",
      searchCondition: "condition",
    }),
    ...mapGetters("DriverAuthentication", ["isDemoEnv"]),
  },
  created() {
    if (this.$route.params.resetCondition) {
      this.resetState();
    }
    if (this.$route.params.resetPagination) {
      this.resetPagination();
    }
    this.searchForm.free_word = this.searchCondition.free_word;
    this.searchForm.subscriberNo = this.searchCondition.number;
    this.searchForm.manifestType = this.searchCondition.manifest_type;
    this.searchForm.billingAddressCode =
      this.searchCondition.billing_address_code;
    this.searchForm.billingAddressName =
      this.searchCondition.billing_address_name;
    this.searchForm.unregisterLocation =
      this.searchCondition.unregister_location;
    this.searchForm.unregisterBillingAddress =
      this.searchCondition.unregister_billing_address;
    this.searchForm.sortType = this.searchCondition.sort_type;
    this.searchForm.mailAddressSetting =
      this.searchCondition.mail_address_setting;
    this.searchForm.ediRequestStatus = this.searchCondition.edi_request_status;
    this.searchForm.dxeEmissionMode = this.searchCondition.dxe_emission_mode;
    this.searchForm.emitterMailApproval =
      this.searchCondition.emitter_mail_approval;
    this.page = this.pagination.current_page;
    this.perPage = this.searchCondition.limit;
    this.searchEmissions();
  },
  methods: {
    ...mapActions("DriverMasterEmission", {
      fetchEmissions: "index",
      resetState: "resetState",
      resetPagination: "resetPagination",
      checkUsers: "check",
      sendEdiApplicationMail: "sendEdiApplicationMail",
    }),
    ...mapActions("DriverMasterOutputCsvEmissionLocation", {
      fetchEmissionLocations: "index",
    }),
    onTableInput(selected) {
      if (Array.isArray(selected)) {
        const filtered = selected.filter((item) => !item.disabled);
        if (filtered.length !== selected.length) {
          this.rowSelected = filtered;
        } else {
          this.rowSelected = selected;
        }
      }
    },
    searchButtonClickEvent() {
      this.page = 1;
      this.searchEmissions();
    },
    /**
     * 追加ボタン押下イベント
     * お試しプランの場合、10人までしか登録できないようにする
     */
    addButtonClickEvent() {
      if (this.isTrialPlan) {
        this.checkUsers().then((content) => {
          if (content.pagination.total_count < 100) {
            this.$router.push({ name: "DriverMasterEmissionNew" });
          } else {
            this.enableTrialPlanGuideDialog = true;
          }
        });
      } else {
        this.$router.push({ name: "DriverMasterEmissionNew" });
      }
    },
    showButtonClickEvent(item) {
      this.$router.push({
        name: "DriverMasterEmission",
        params: { id: item.id },
      });
    },
    editButtonClickEvent(item) {
      this.$router.push({
        name: "DriverMasterEmissionEdit",
        params: { id: item.id },
      });
    },
    importEmissionButtonClickEvent() {
      this.$router.push({ name: "DriverMasterEmissionCsvImport" });
    },
    exportEmissionButtonClickEvent() {
      let params = this.buildParam("csv");
      this.fetchEmissions(params).then((content) => {
        this.downloadCsv(content, "排出事業者");
      });
    },
    importLocationButtonClickEvent() {
      this.$router.push({ name: "DriverMasterEmissionLocationCsvImport" });
    },
    exportLocationButtonClickEvent() {
      let params = this.buildParam("csv");
      this.fetchEmissionLocations({ conditions: params }).then((content) => {
        this.downloadCsv(content, "排出事業場");
      });
    },
    changePage(page) {
      this.page = page;
      this.searchEmissions();
    },
    changePerPage(perPage) {
      this.perPage = perPage;
      this.page = 1;
      this.searchEmissions();
    },
    /**
     * チェックボックスの一括切替 クリックイベント
     */
    selectedAllCheckboxClickEvent(selectedItems) {
      let items = selectedItems.items;
      let isSelected = selectedItems.value;

      if (isSelected) {
        // 選択可能なアイテムがすべて選択されているかチェック
        const selectableItems = items.filter((item) => !item.disabled);
        const allSelected = selectableItems.every((item) =>
          this.rowSelected.includes(item)
        );

        if (allSelected) {
          // すべて選択済みの場合は解除
          for (let item of items) {
            item.selected = false;
          }
          this.rowSelected = [];
        } else {
          // 未選択のアイテムを選択
          for (let item of items) {
            if (!item.disabled) {
              item.selected = true;
              if (!this.rowSelected.includes(item)) {
                this.rowSelected.push(item);
              }
            }
          }
        }
      } else {
        // 全解除
        for (let item of items) {
          item.selected = false;
        }
        this.rowSelected = [];
      }
    },
    searchEmissions() {
      let params = this.buildParam("json");
      this.fetchEmissions(params).then((content) => {
        // 各アイテムにdisabledプロパティを追加
        this.emissions = content.emissions.map((emission) => {
          return {
            ...emission,
            disabled: this.isItemDisabled(emission),
          };
        });
      });
    },
    buildParam(format) {
      return {
        free_word: this.searchForm.free_word,
        number: this.searchForm.subscriberNo,
        manifest_type: this.searchForm.manifestType,
        billing_address_code: this.searchForm.billingAddressCode,
        billing_address_name: this.searchForm.billingAddressName,
        unregister_location: this.searchForm.unregisterLocation,
        unregister_billing_address: this.searchForm.unregisterBillingAddress,
        sort_type: this.searchForm.sortType,
        mail_address_setting: this.searchForm.mailAddressSetting,
        edi_request_status: this.searchForm.ediRequestStatus,
        dxe_emission_mode: this.searchForm.dxeEmissionMode,
        emitter_mail_approval: this.searchForm.emitterMailApproval,
        page: this.page,
        limit: this.perPage,
        format: format,
      };
    },
    /**
     * ダイアログ 閉じるボタンコールバック
     */
    dialogCloseCallback() {
      this.enableTrialPlanGuideDialog = false;
    },
    /**
     * チェックボックスを無効化するかどうかの判定
     */
    isItemDisabled(emission) {
      // 既にEDI申込済み、またはEDI利用可能、またはEDI利用完了の場合
      const disabledStatuses = [
        "emission_requested",
        "jwnet_requested",
        "edi_available",
        "edi_completed",
      ];
      if (
        emission.edi_request_status &&
        disabledStatuses.includes(emission.edi_request_status)
      ) {
        return true;
      }
      // メールアドレス1未設定の場合
      if (!emission.email_1 || emission.email_1.trim() === "") {
        return true;
      }
      // dxe_formの場合はメール送信対象外
      if (emission.manifest_type === "dxe_form") {
        return true;
      }
      return false;
    },
    /**
     * チェックボックスの一括切替 クリックイベント
     */
    /**
     * 行選択のトグル
     */
    /**
     * 行選択トグル
     */
    toggleRowSelection(item) {
      if (item.disabled) {
        return;
      }
      const index = this.rowSelected.findIndex((row) => row === item);
      if (index > -1) {
        this.rowSelected.splice(index, 1);
        item.selected = false;
        // Vuex反映（必要なら）
        // this.removeItem({item: item});
      } else {
        this.rowSelected.push(item);
        item.selected = true;
        // Vuex反映（必要なら）
        // this.setIndividualItem({item: item});
      }
    },
    /**
     * チェックボックス クリックイベント
     */
    checkboxClickEvent(item) {
      if (item.selected) {
        // this.setIndividualItem({item: item})
      } else {
        // this.removeItem({item: item})
      }
    },
    /**
     * EDI申込メール送信ボタン押下イベント
     */
    sendEdiApplicationMailButtonClickEvent() {
      if (this.rowSelected.length === 0) {
        return;
      }

      this.$refs.confirm
        .open({
          title: "確認",
          message: "メール送信しますよろしいですか？",
          options: {},
        })
        .then((confirm) => {
          this.$refs.confirm.close();
          if (!confirm) {
            return;
          }

          const emissionIds = this.rowSelected.map((item) => item.id);

          this.sendEdiApplicationMail({ emission_ids: emissionIds })
            .then(() => {
              this.$store.commit(
                "snackbar/showSuccess",
                {
                  message: "EDI申込mailを送信しました",
                },
                { root: true }
              );
              // 選択をクリア
              this.rowSelected = [];
              // リストを再読み込み
              this.searchEmissions();
            })
            .catch((error) => {
              // エラーハンドリングはアクション内またはインターセプターで処理される
            });
        });
    },
  },
};
</script>

<style scoped lang="scss">
.panel-header-color {
  color: #0d74ba !important;
  & .v-expansion-panel-header__icon {
    & .v-icon {
      color: #0d74ba !important;
      &::before {
        color: #0d74ba !important;
      }
    }
  }
}
.panel-selectable {
  background-color: #dce7eb;
}

// 無効化されたチェックボックスのスタイル
::v-deep .disabled-checkbox {
  .v-icon {
    color: #bdbdbd !important;
  }
  opacity: 0.5;
  cursor: not-allowed !important;
}
</style>
